// Import Auth0 at the very top (for bundling)
import { createAuth0Client } from '@auth0/auth0-spa-js';

document.addEventListener('DOMContentLoaded', function() {
    // ==== AUTH0 SETUP ====
    let auth0 = null;
    let currentUser = null;
    
    // Auth0 configuration
    const auth0Config = {
        domain: 'dev-7hxzk1483lfzondn.us.auth0.com',
        clientId: 'HEKjfMdnpNpvYaU6aeKh0UYweDlFxWkI',
        authorizationParams: {
            redirect_uri: window.location.origin
        }
    };

    // Initialize Auth0
    async function initAuth0() {
        try {
            auth0 = await createAuth0Client(auth0Config);
            
            // Check if returning from redirect
            if (location.search.includes('code=')) {
                await auth0.handleRedirectCallback();
                window.history.replaceState({}, document.title, location.pathname);
            }
            
            // Check if user is authenticated
            const isAuthenticated = await auth0.isAuthenticated();
            if (isAuthenticated) {
                currentUser = await auth0.getUser();
                console.log('User authenticated:', currentUser);
            }
            
            updateAuthUI();
        } catch (error) {
            console.error('Auth0 initialization failed:', error);
            showNotification('Authentication setup failed', 'error');
        }
    }

    // Auth functions
    async function login() {
        try {
            if (!auth0) {
                showNotification('Authentication not ready, please wait...', 'error');
                return;
            }
            await auth0.loginWithRedirect();
        } catch (error) {
            console.error('Login failed:', error);
            showNotification('Login failed, please try again', 'error');
        }
    }

    async function logout() {
        try {
            if (!auth0) return;
            await auth0.logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            });
        } catch (error) {
            console.error('Logout failed:', error);
        }
    }

    // Auth UI elements
    const loginBtn = document.getElementById('loginBtn');
    const logoutBtn = document.getElementById('logoutBtn');

    function updateAuthUI() {
        const isLoggedIn = !!currentUser;
        document.body.classList.toggle('logged-in', isLoggedIn);
        document.body.classList.toggle('logged-out', !isLoggedIn);
        
        if (loginBtn && logoutBtn) {
            loginBtn.style.display = isLoggedIn ? 'none' : '';
            logoutBtn.style.display = isLoggedIn ? '' : 'none';
        }
        
        // Update user info display
        const userInfo = document.querySelector('.user-info');
        if (userInfo && currentUser) {
            userInfo.textContent = `Welcome, ${currentUser.name || currentUser.email}`;
            userInfo.style.display = '';
        } else if (userInfo) {
            userInfo.style.display = 'none';
        }
        
        loadFromLocalStorage();
        renderLeaderboard();
    }

    // Set up event listeners after Auth0 is ready
    if (loginBtn) loginBtn.addEventListener('click', login);
    if (logoutBtn) logoutBtn.addEventListener('click', logout);

    // Initialize Auth0 first
    initAuth0();

    // ==== REST OF YOUR EXISTING CODE ====
    
    // Leaderboard elements
    const leaderboardEl = document.getElementById('leaderboard');
    const leaderboardBtns = document.querySelectorAll('.leaderboard-period');
    const screenshotInput = document.getElementById('screenshotUpload');
    const submitScreenshotBtn = document.getElementById('submitScreenshot');

    // Enhanced Journal elements
    const screenshotModeBtn = document.getElementById('screenshotModeBtn');
    const manualModeBtn = document.getElementById('manualModeBtn');
    const screenshotMode = document.getElementById('screenshotMode');
    const manualMode = document.getElementById('manualMode');
    const tradeScreenshot = document.getElementById('tradeScreenshot');
    const processScreenshot = document.getElementById('processScreenshot');
    const enhancedTradeForm = document.getElementById('enhancedTradeForm');

    // ==== ENHANCED JOURNAL MODE SWITCHING ====
    if (screenshotModeBtn && manualModeBtn) {
        screenshotModeBtn.addEventListener('click', function() {
            switchToScreenshotMode();
        });
        manualModeBtn.addEventListener('click', function() {
            switchToManualMode();
        });
    }

    function switchToScreenshotMode() {
        if (screenshotModeBtn) screenshotModeBtn.classList.add('active');
        if (manualModeBtn) manualModeBtn.classList.remove('active');
        if (screenshotMode) screenshotMode.classList.remove('hidden');
        if (manualMode) manualMode.classList.add('hidden');
    }

    function switchToManualMode() {
        if (manualModeBtn) manualModeBtn.classList.add('active');
        if (screenshotModeBtn) screenshotModeBtn.classList.remove('active');
        if (manualMode) manualMode.classList.remove('hidden');
        if (screenshotMode) screenshotMode.classList.add('hidden');
    }

    // ==== TRADE TYPE SWITCHING ====
    const tradeTypeButtons = document.querySelectorAll('.trade-type-btn');
    let currentTradeType = 'stock';

    tradeTypeButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            // Update active button
            tradeTypeButtons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            
            // Hide all form fields
            document.querySelectorAll('.trade-fields').forEach(field => field.classList.add('hidden'));
            
            // Show selected form fields
            currentTradeType = this.dataset.type;
            const selectedFields = document.querySelector(`.${currentTradeType}-fields`);
            if (selectedFields) {
                selectedFields.classList.remove('hidden');
            }
        });
    });

    // ==== SCREENSHOT PROCESSING ====
    if (processScreenshot && tradeScreenshot) {
        processScreenshot.addEventListener('click', function() {
            const file = tradeScreenshot.files[0];
            if (!file) {
                showNotification('Please select a screenshot file', 'error');
                return;
            }
            processTradeScreenshot(file);
        });
    }

    // Enhanced screenshot processing with Netlify Functions + Google Vision API
    async function processTradeScreenshot(imageFile) {
        try {
            showNotification('Processing screenshot with Google Vision API...', 'info');
            
            // Create form data
            const formData = new FormData();
            formData.append('image', imageFile);
            
            // Call your Netlify function
            const response = await fetch('/.netlify/functions/process-screenshot', {
                method: 'POST',
                body: formData
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }
            
            const result = await response.json();
            
            if (result.success) {
                console.log('OCR Result:', result);
                showNotification(`OCR completed with ${result.confidence}% confidence`, 'success');
                displayExtractedDataWithCorrection(result.tradeData, result.extractedText);
            } else {
                throw new Error(result.error || 'OCR processing failed');
            }
            
        } catch (error) {
            console.error('OCR Error:', error);
            showNotification('Error processing screenshot: ' + error.message, 'error');
            // Fallback to manual entry
            switchToManualMode();
        }
    }

    // Enhanced display of extracted data with correction interface
    function displayExtractedDataWithCorrection(tradeData, rawText) {
        const extractedDataDiv = document.getElementById('extractedData');
        const tradeInfoDiv = document.getElementById('extractedTradeInfo');
        
        if (!extractedDataDiv || !tradeInfoDiv) {
            console.error('Extracted data elements not found');
            return;
        }
        
        // Create correction interface
        tradeInfoDiv.innerHTML = `
            <div class="extracted-trade-correction">
                <div class="raw-text-section">
                    <h4>Raw OCR Text:</h4>
                    <div class="raw-text">${rawText}</div>
                </div>
                <div class="correction-form">
                    <h4>Extracted Trade Details (Please verify and correct):</h4>
                    <div class="correction-row">
                        <label>Symbol:</label>
                        <input type="text" id="corrected-symbol" value="${tradeData.symbol || ''}" placeholder="e.g., AAPL">
                    </div>
                    <div class="correction-row">
                        <label>Trade Type:</label>
                        <select id="corrected-type">
                            <option value="long" ${tradeData.type === 'long' ? 'selected' : ''}>Long</option>
                            <option value="short" ${tradeData.type === 'short' ? 'selected' : ''}>Short</option>
                        </select>
                    </div>
                    <div class="correction-row">
                        <label>Entry Price:</label>
                        <input type="number" id="corrected-entry" value="${tradeData.entryPrice || ''}" placeholder="0.00" step="0.01">
                    </div>
                    <div class="correction-row">
                        <label>Exit Price:</label>
                        <input type="number" id="corrected-exit" value="${tradeData.exitPrice || ''}" placeholder="0.00" step="0.01">
                    </div>
                    <div class="correction-row">
                        <label>Position Size:</label>
                        <input type="number" id="corrected-size" value="${tradeData.positionSize || ''}" placeholder="100" step="1">
                    </div>
                    <div class="correction-row">
                        <label>P&L:</label>
                        <input type="number" id="corrected-pnl" value="${tradeData.pnl || ''}" placeholder="0.00" step="0.01">
                    </div>
                </div>
            </div>
        `;
        
        extractedDataDiv.classList.remove('hidden');
        
        // Setup correction buttons
        const confirmBtn = document.getElementById('confirmExtractedTrade');
        const editBtn = document.getElementById('editExtractedTrade');
        
        if (confirmBtn) {
            confirmBtn.onclick = function() {
                const correctedData = {
                    symbol: document.getElementById('corrected-symbol').value,
                    type: document.getElementById('corrected-type').value,
                    entryPrice: parseFloat(document.getElementById('corrected-entry').value),
                    exitPrice: parseFloat(document.getElementById('corrected-exit').value),
                    positionSize: parseInt(document.getElementById('corrected-size').value),
                    pnl: parseFloat(document.getElementById('corrected-pnl').value)
                };
                addTradeFromExtractedData(correctedData);
                extractedDataDiv.classList.add('hidden');
            };
        }
        
        if (editBtn) {
            editBtn.onclick = function() {
                const correctedData = {
                    symbol: document.getElementById('corrected-symbol').value,
                    type: document.getElementById('corrected-type').value,
                    entryPrice: document.getElementById('corrected-entry').value,
                    exitPrice: document.getElementById('corrected-exit').value,
                    positionSize: document.getElementById('corrected-size').value,
                    pnl: document.getElementById('corrected-pnl').value
                };
                fillManualFormWithData(correctedData);
                switchToManualMode();
                extractedDataDiv.classList.add('hidden');
            };
        }
    }

    function addTradeFromExtractedData(data) {
        const trade = {
            id: Date.now(),
            symbol: data.symbol,
            type: data.type,
            entryPrice: data.entryPrice,
            exitPrice: data.exitPrice,
            positionSize: data.positionSize,
            pnl: data.pnl,
            timestamp: new Date().toISOString(),
            source: 'screenshot'
        };
        
        addTrade(trade);
        showNotification('Trade added successfully from screenshot!', 'success');
    }

    function fillManualFormWithData(data) {
        // Fill the manual form with extracted data
        const symbolField = document.getElementById('symbol');
        const sideField = document.getElementById('side');
        const entryField = document.getElementById('entryPrice');
        const exitField = document.getElementById('exitPrice');
        const quantityField = document.getElementById('quantity');
        
        if (symbolField) symbolField.value = data.symbol || '';
        if (sideField) sideField.value = data.type || '';
        if (entryField) entryField.value = data.entryPrice || '';
        if (exitField) exitField.value = data.exitPrice || '';
        if (quantityField) quantityField.value = data.positionSize || '';
        
        // Recalculate P&L
        calculateRealTimePnL();
    }

    // ==== REAL-TIME P&L CALCULATION ====
    function calculateRealTimePnL() {
        const entryPrice = parseFloat(document.getElementById('entryPrice')?.value) || 0;
        const exitPrice = parseFloat(document.getElementById('exitPrice')?.value) || 0;
        const quantity = parseInt(document.getElementById('quantity')?.value) || 0;
        const side = document.getElementById('side')?.value;
        
        let pnl = 0;
        if (entryPrice && exitPrice && quantity) {
            if (side === 'long') {
                pnl = (exitPrice - entryPrice) * quantity;
            } else if (side === 'short') {
                pnl = (entryPrice - exitPrice) * quantity;
            }
        }
        
        const pnlDisplay = document.getElementById('calculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        
        return pnl;
    }

    // Add event listeners for real-time calculation
    ['entryPrice', 'exitPrice', 'quantity', 'side'].forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateRealTimePnL);
            element.addEventListener('change', calculateRealTimePnL);
        }
    });

    // ==== OPTIONS P&L CALCULATION ====
    function calculateOptionsPnL() {
        const entryPremium = parseFloat(document.getElementById('entryPremium')?.value) || 0;
        const exitPremium = parseFloat(document.getElementById('exitPremium')?.value) || 0;
        const contracts = parseInt(document.getElementById('contracts')?.value) || 0;
        const side = document.getElementById('optionSide')?.value;
        
        let pnl = 0;
        if (entryPremium && exitPremium && contracts) {
            if (side === 'buy') {
                pnl = (exitPremium - entryPremium) * contracts * 100;
            } else if (side === 'sell') {
                pnl = (entryPremium - exitPremium) * contracts * 100;
            }
        }
        
        const pnlDisplay = document.getElementById('optionsCalculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        
        return pnl;
    }

    // Add event listeners for options calculation
    ['entryPremium', 'exitPremium', 'contracts', 'optionSide'].forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateOptionsPnL);
            element.addEventListener('change', calculateOptionsPnL);
        }
    });

    // ==== FUTURES P&L CALCULATION ====
    function calculateFuturesPnL() {
        const entryPrice = parseFloat(document.getElementById('futuresEntryPrice')?.value) || 0;
        const exitPrice = parseFloat(document.getElementById('futuresExitPrice')?.value) || 0;
        const contracts = parseInt(document.getElementById('futuresContracts')?.value) || 0;
        const side = document.getElementById('futuresSide')?.value;
        const symbol = document.getElementById('futuresSymbol')?.value?.toUpperCase();
        
        // Contract multipliers
        const multipliers = {
            'ES': 50, 'MES': 5, 'NQ': 20, 'MNQ': 2, 'YM': 5, 'MYM': 0.5,
            'RTY': 50, 'M2K': 5, 'CL': 1000, 'GC': 100, 'SI': 5000, 'ZN': 1000
        };
        
        const multiplier = multipliers[symbol] || 50; // Default to ES multiplier
        
        let pnl = 0;
        if (entryPrice && exitPrice && contracts) {
            const pointDifference = side === 'long' ? (exitPrice - entryPrice) : (entryPrice - exitPrice);
            pnl = pointDifference * contracts * multiplier;
        }
        
        const pnlDisplay = document.getElementById('futuresCalculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        
        return pnl;
    }

    // Add event listeners for futures calculation
    ['futuresEntryPrice', 'futuresExitPrice', 'futuresContracts', 'futuresSide', 'futuresSymbol'].forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateFuturesPnL);
            element.addEventListener('change', calculateFuturesPnL);
        }
    });

    // ==== CRYPTO P&L CALCULATION ====
    function calculateCryptoPnL() {
        const entryPrice = parseFloat(document.getElementById('cryptoEntryPrice')?.value) || 0;
        const exitPrice = parseFloat(document.getElementById('cryptoExitPrice')?.value) || 0;
        const quantity = parseFloat(document.getElementById('cryptoQuantity')?.value) || 0;
        const side = document.getElementById('cryptoSide')?.value;
        
        let pnl = 0;
        if (entryPrice && exitPrice && quantity) {
            if (side === 'long') {
                pnl = (exitPrice - entryPrice) * quantity;
            } else if (side === 'short') {
                pnl = (entryPrice - exitPrice) * quantity;
            }
        }
        
        const pnlDisplay = document.getElementById('cryptoCalculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        
        return pnl;
    }

    // Add event listeners for crypto calculation
    ['cryptoEntryPrice', 'cryptoExitPrice', 'cryptoQuantity', 'cryptoSide'].forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateCryptoPnL);
            element.addEventListener('change', calculateCryptoPnL);
        }
    });

    // ==== DATA STORAGE ====
    let trades = [];
    let leaderboardData = JSON.parse(localStorage.getItem('leaderboardData') || '{"monthly":[],"weekly":[]}');
    let currentPeriod = 'monthly';

    function loadFromLocalStorage() {
        // Only load data if user is authenticated
        if (!currentUser) {
            trades = [];
            return;
        }
        
        const today = new Date().toDateString();
        const savedTrades = localStorage.getItem(`trades_${today}_${currentUser.sub}`);
        if (savedTrades) {
            trades = JSON.parse(savedTrades);
        } else {
            trades = [];
        }
        
        updateTradesDisplay();
        updateStatistics();
        updateCapitalDisplay();
        updateDailyProgress();
    }

    function saveToLocalStorage() {
        if (!currentUser) return;
        
        const today = new Date().toDateString();
        localStorage.setItem(`trades_${today}_${currentUser.sub}`, JSON.stringify(trades));
        localStorage.setItem('leaderboardData', JSON.stringify(leaderboardData));
        updateLeaderboard();
    }

    // ==== ENHANCED TRADE FORM SUBMISSION ====
    if (enhancedTradeForm) {
        enhancedTradeForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            if (!currentUser) {
                showNotification('Please log in to add trades', 'error');
                return;
            }
            
            let trade = {};
            
            // Get trade data based on current trade type
            switch (currentTradeType) {
                case 'stock':
                    trade = {
                        id: Date.now(),
                        type: currentTradeType,
                        symbol: document.getElementById('symbol').value.toUpperCase(),
                        side: document.getElementById('side').value,
                        entryPrice: parseFloat(document.getElementById('entryPrice').value),
                        exitPrice: parseFloat(document.getElementById('exitPrice').value),
                        quantity: parseInt(document.getElementById('quantity').value),
                        pnl: calculateRealTimePnL(),
                        timestamp: new Date().toISOString()
                    };
                    break;
                    
                case 'options':
                    trade = {
                        id: Date.now(),
                        type: currentTradeType,
                        symbol: document.getElementById('optionsSymbol').value.toUpperCase(),
                        optionType: document.getElementById('optionType').value,
                        strike: parseFloat(document.getElementById('strike').value),
                        expiration: document.getElementById('expiration').value,
                        side: document.getElementById('optionSide').value,
                        contracts: parseInt(document.getElementById('contracts').value),
                        entryPremium: parseFloat(document.getElementById('entryPremium').value),
                        exitPremium: parseFloat(document.getElementById('exitPremium').value),
                        pnl: calculateOptionsPnL(),
                        timestamp: new Date().toISOString()
                    };
                    break;
                    
                case 'futures':
                    trade = {
                        id: Date.now(),
                        type: currentTradeType,
                        symbol: document.getElementById('futuresSymbol').value.toUpperCase(),
                        side: document.getElementById('futuresSide').value,
                        contracts: parseInt(document.getElementById('futuresContracts').value),
                        entryPrice: parseFloat(document.getElementById('futuresEntryPrice').value),
                        exitPrice: parseFloat(document.getElementById('futuresExitPrice').value),
                        pnl: calculateFuturesPnL(),
                        timestamp: new Date().toISOString()
                    };
                    break;
                    
                case 'crypto':
                    trade = {
                        id: Date.now(),
                        type: currentTradeType,
                        symbol: document.getElementById('cryptoSymbol').value.toUpperCase(),
                        side: document.getElementById('cryptoSide').value,
                        quantity: parseFloat(document.getElementById('cryptoQuantity').value),
                        entryPrice: parseFloat(document.getElementById('cryptoEntryPrice').value),
                        exitPrice: parseFloat(document.getElementById('cryptoExitPrice').value),
                        pnl: calculateCryptoPnL(),
                        timestamp: new Date().toISOString()
                    };
                    break;
            }
            
            // Validate trade
            if (!trade.symbol || (!trade.pnl && trade.pnl !== 0)) {
                showNotification('Please fill in all required fields', 'error');
                return;
            }
            
            addTrade(trade);
            enhancedTradeForm.reset();
            
            // Reset to first trade type and show stock fields
            document.querySelector('.trade-type-btn[data-type="stock"]').click();
            
            showNotification('Trade added successfully!', 'success');
        });
    }

    function addTrade(trade) {
        trades.push(trade);
        updateTradesDisplay();
        updateStatistics();
        updateCapitalDisplay();
        updateDailyProgress();
        saveToLocalStorage();
        
        // Check daily goal
        checkDailyGoal();
    }

    // ==== TRADES DISPLAY ====
    function updateTradesDisplay() {
        const tradesList = document.getElementById('tradesList');
        if (!tradesList) return;
        
        if (trades.length === 0) {
            tradesList.innerHTML = '<p class="no-trades">No trades recorded yet</p>';
            return;
        }
        
        let tradesHTML = '';
        trades.forEach((trade, index) => {
            const time = new Date(trade.timestamp).toLocaleTimeString();
            const pnlClass = trade.pnl >= 0 ? 'positive' : 'negative';
            
            let tradeDetails = '';
            switch (trade.type) {
                case 'stock':
                    tradeDetails = `${trade.quantity} shares @ $${trade.entryPrice} → $${trade.exitPrice}`;
                    break;
                case 'options':
                    tradeDetails = `${trade.contracts} contracts ${trade.optionType} $${trade.strike} @ $${trade.entryPremium} → $${trade.exitPremium}`;
                    break;
                case 'futures':
                    tradeDetails = `${trade.contracts} contracts @ $${trade.entryPrice} → $${trade.exitPrice}`;
                    break;
                case 'crypto':
                    tradeDetails = `${trade.quantity} units @ $${trade.entryPrice} → $${trade.exitPrice}`;
                    break;
            }
            
            tradesHTML += `
                <div class="trade-item">
                    <div class="trade-header">
                        <span class="trade-symbol">${trade.symbol} (${trade.type})</span>
                        <span class="trade-side ${trade.side}">${trade.side?.toUpperCase()}</span>
                        <span class="trade-pnl ${pnlClass}">${trade.pnl >= 0 ? '+' : ''}$${trade.pnl.toFixed(2)}</span>
                        <span class="trade-time">${time}</span>
                    </div>
                    <div class="trade-details">${tradeDetails}</div>
                    <div class="trade-actions">
                        <button class="btn btn--sm btn--outline" onclick="editTrade(${index})">Edit</button>
                        <button class="btn btn--sm btn--danger" onclick="deleteTrade(${index})">Delete</button>
                    </div>
                </div>
            `;
        });
        
        tradesList.innerHTML = tradesHTML;
    }

    // Make functions global for onclick handlers
    window.editTrade = function(index) {
        const trade = trades[index];
        showNotification('Edit functionality coming soon!', 'info');
    };

    window.deleteTrade = function(index) {
        if (confirm('Are you sure you want to delete this trade?')) {
            trades.splice(index, 1);
            updateTradesDisplay();
            updateStatistics();
            updateCapitalDisplay();
            updateDailyProgress();
            saveToLocalStorage();
            showNotification('Trade deleted', 'success');
        }
    };

    // ==== STATISTICS ====
    function updateStatistics() {
        const totalTradesEl = document.getElementById('totalTrades');
        const winRateEl = document.getElementById('winRate');
        const bestTradeEl = document.getElementById('bestTrade');
        const worstTradeEl = document.getElementById('worstTrade');
        
        if (!totalTradesEl) return;
        
        const totalTrades = trades.length;
        const winningTrades = trades.filter(t => t.pnl > 0).length;
        const winRate = totalTrades > 0 ? (winningTrades / totalTrades * 100).toFixed(1) : 0;
        const pnls = trades.map(t => t.pnl);
        const bestTrade = pnls.length > 0 ? Math.max(...pnls) : 0;
        const worstTrade = pnls.length > 0 ? Math.min(...pnls) : 0;
        
        totalTradesEl.textContent = totalTrades;
        winRateEl.textContent = `${winRate}%`;
        bestTradeEl.textContent = `$${bestTrade.toFixed(2)}`;
        worstTradeEl.textContent = `$${worstTrade.toFixed(2)}`;
    }

    // ==== DAILY PROGRESS ====
    function updateDailyProgress() {
        const dailyPnLEl = document.getElementById('dailyPnL');
        const progressFillEl = document.getElementById('progressFill');
        const dailyGoalInput = document.getElementById('dailyGoal');
        
        if (!dailyPnLEl) return;
        
        const dailyPnL = trades.reduce((sum, trade) => sum + trade.pnl, 0);
        const dailyGoal = parseFloat(dailyGoalInput?.value) || 0;
        
        dailyPnLEl.textContent = `${dailyPnL >= 0 ? '+' : ''}$${dailyPnL.toFixed(2)}`;
        dailyPnLEl.className = `summary-value ${dailyPnL >= 0 ? 'positive' : 'negative'}`;
        
        if (dailyGoal > 0 && progressFillEl) {
            const progress = Math.min((dailyPnL / dailyGoal) * 100, 100);
            progressFillEl.style.width = `${Math.max(progress, 0)}%`;
            
            if (progress >= 100) {
                progressFillEl.classList.add('goal-achieved');
            } else {
                progressFillEl.classList.remove('goal-achieved');
            }
        }
    }

    function checkDailyGoal() {
        const dailyGoalInput = document.getElementById('dailyGoal');
        const dailyGoal = parseFloat(dailyGoalInput?.value) || 0;
        
        if (dailyGoal > 0) {
            const dailyPnL = trades.reduce((sum, trade) => sum + trade.pnl, 0);
            
            if (dailyPnL >= dailyGoal) {
                showCelebrationModal(dailyGoal, dailyPnL);
            }
        }
    }

    function showCelebrationModal(goal, achieved) {
        const modal = document.getElementById('celebrationModal');
        const goalSpan = document.getElementById('celebrationGoal');
        const achievedSpan = document.getElementById('celebrationAchieved');
        
        if (modal && goalSpan && achievedSpan) {
            goalSpan.textContent = goal.toFixed(2);
            achievedSpan.textContent = achieved.toFixed(2);
            modal.classList.remove('hidden');
        }
    }

    // ==== CAPITAL MANAGEMENT ====
    function updateCapitalDisplay() {
        const originalCapitalEl = document.getElementById('originalCapitalDisplay');
        const totalProfitsEl = document.getElementById('totalProfitsDisplay');
        const newCapitalEl = document.getElementById('newCapitalDisplay');
        const profitAdditionEl = document.getElementById('profitAddition');
        const profitAmountEl = document.getElementById('profitAmount');
        const updateBtn = document.getElementById('updateCapitalFromProfits');
        
        if (!originalCapitalEl) return;
        
        const capital = parseFloat(document.getElementById('capital')?.value) || 0;
        const totalPnL = trades.reduce((sum, trade) => sum + trade.pnl, 0);
        const newCapital = capital + totalPnL;
        
        originalCapitalEl.textContent = `$${capital.toLocaleString()}`;
        totalProfitsEl.textContent = `${totalPnL >= 0 ? '+' : ''}$${totalPnL.toFixed(2)}`;
        totalProfitsEl.className = `capital-value ${totalPnL >= 0 ? 'positive' : 'negative'}`;
        newCapitalEl.textContent = `$${newCapital.toLocaleString()}`;
        
        if (totalPnL !== 0) {
            profitAmountEl.textContent = `${totalPnL >= 0 ? '+' : ''}$${totalPnL.toFixed(2)}`;
            profitAdditionEl.style.display = '';
            if (updateBtn) updateBtn.disabled = false;
        } else {
            profitAdditionEl.style.display = 'none';
            if (updateBtn) updateBtn.disabled = true;
        }
    }

    // ==== RISK CALCULATOR ====
    const calculateRiskBtn = document.getElementById('calculateRisk');
    const riskButtons = document.querySelectorAll('.risk-btn');
    let selectedRisk = null;

    riskButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            riskButtons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            selectedRisk = this.dataset.risk;
        });
    });

    if (calculateRiskBtn) {
        calculateRiskBtn.addEventListener('click', function() {
            const capital = parseFloat(document.getElementById('capital').value);
            
            if (!capital || capital <= 0) {
                showNotification('Please enter a valid trading capital amount', 'error');
                return;
            }
            
            if (!selectedRisk) {
                showNotification('Please select a risk tolerance level', 'error');
                return;
            }
            
            const riskPercentages = {
                safe: 0.015,
                risky: 0.025,
                highRisk: 0.04
            };
            
            const riskPercent = riskPercentages[selectedRisk];
            const riskPerTrade = capital * riskPercent;
            const maxDailyLoss = capital * (riskPercent * 3);
            
            document.getElementById('riskPerTrade').textContent = `$${riskPerTrade.toFixed(2)}`;
            document.getElementById('maxDailyLoss').textContent = `$${maxDailyLoss.toFixed(2)}`;
            document.getElementById('riskAmount').textContent = `$${riskPerTrade.toFixed(2)}`;
            document.getElementById('riskReward').textContent = '1:2 minimum';
            
            document.getElementById('riskResults').classList.remove('hidden');
            
            // Update capital displays
            updateCapitalDisplay();
        });
    }

    // ==== LEADERBOARD ====
    function renderLeaderboard() {
        if (!currentUser) return;
        
        const period = currentPeriod;
        const data = leaderboardData[period] || [];
        
        // Add current user's performance
        const todaysPnL = trades.reduce((sum, trade) => sum + trade.pnl, 0);
        const userEntry = {
            name: currentUser.name || currentUser.email,
            pnl: todaysPnL,
            verified: false
        };
        
        // Update or add user entry
        const existingIndex = data.findIndex(entry => entry.name === userEntry.name);
        if (existingIndex >= 0) {
            data[existingIndex].pnl = userEntry.pnl;
        } else {
            data.push(userEntry);
        }
        
        // Sort by P&L
        data.sort((a, b) => b.pnl - a.pnl);
        
        const leaderboardEl = document.getElementById('leaderboard');
        if (leaderboardEl) {
            let html = '<div class="leaderboard-list">';
            
            data.slice(0, 10).forEach((entry, index) => {
                const rank = index + 1;
                const isCurrentUser = entry.name === userEntry.name;
                
                html += `
                    <div class="leaderboard-item ${isCurrentUser ? 'current-user' : ''}">
                        <span class="rank">#${rank}</span>
                        <span class="name">${entry.name} ${entry.verified ? '✅' : ''}</span>
                        <span class="pnl ${entry.pnl >= 0 ? 'positive' : 'negative'}">
                            ${entry.pnl >= 0 ? '+' : ''}$${entry.pnl.toFixed(2)}
                        </span>
                    </div>
                `;
            });
            
            html += '</div>';
            leaderboardEl.innerHTML = html;
        }
        
        // Update leaderboard data
        leaderboardData[period] = data;
        localStorage.setItem('leaderboardData', JSON.stringify(leaderboardData));
    }

    function updateLeaderboard() {
        renderLeaderboard();
    }

    // Leaderboard period switching
    leaderboardBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            leaderboardBtns.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            currentPeriod = this.dataset.period;
            renderLeaderboard();
        });
    });

    // ==== SCREENSHOT UPLOAD FOR VERIFICATION ====
    if (submitScreenshotBtn && screenshotInput) {
        submitScreenshotBtn.addEventListener('click', function() {
            const file = screenshotInput.files[0];
            if (!file) {
                showNotification('Please select a screenshot', 'error');
                return;
            }
            
            showNotification('Processing verification screenshot...', 'info');
            
            setTimeout(() => {
                showNotification('P&L verified successfully! ✅', 'success');
                const period = currentPeriod;
                const data = leaderboardData[period] || [];
                const userEntry = data.find(entry => entry.name === (currentUser.name || currentUser.email));
                if (userEntry) {
                    userEntry.verified = true;
                    renderLeaderboard();
                }
            }, 2000);
        });
    }

    // ==== UTILITY FUNCTIONS ====
    function showNotification(message, type = 'info') {
        let notification = document.getElementById('notification');
        if (!notification) {
            notification = document.createElement('div');
            notification.id = 'notification';
            notification.className = 'notification';
            document.body.appendChild(notification);
        }
        
        notification.textContent = message;
        notification.className = `notification ${type} show`;
        
        setTimeout(() => {
            notification.classList.remove('show');
        }, 3000);
    }

    // ==== EXPORT FUNCTIONALITY ====
    const exportBtn = document.getElementById('exportTrades');
    if (exportBtn) {
        exportBtn.addEventListener('click', function() {
            if (trades.length === 0) {
                showNotification('No trades to export', 'error');
                return;
            }
            
            const csvContent = generateCSV(trades);
            downloadCSV(csvContent, `trades_${new Date().toDateString()}.csv`);
            showNotification('Trades exported successfully!', 'success');
        });
    }

    function generateCSV(trades) {
        const headers = ['Timestamp', 'Symbol', 'Type', 'Side', 'Entry Price', 'Exit Price', 'Quantity/Contracts', 'P&L'];
        const rows = trades.map(trade => [
            new Date(trade.timestamp).toLocaleString(),
            trade.symbol,
            trade.type,
            trade.side || '',
            trade.entryPrice || trade.entryPremium || '',
            trade.exitPrice || trade.exitPremium || '',
            trade.quantity || trade.contracts || '',
            trade.pnl.toFixed(2)
        ]);
        
        return [headers, ...rows].map(row => row.join(',')).join('\n');
    }

    function downloadCSV(content, filename) {
        const blob = new Blob([content], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    // ==== CLEAR ALL TRADES ====
    const clearAllBtn = document.getElementById('clearAllTrades');
    if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function() {
            if (confirm('Are you sure you want to clear all trades? This cannot be undone.')) {
                trades = [];
                updateTradesDisplay();
                updateStatistics();
                updateCapitalDisplay();
                updateDailyProgress();
                saveToLocalStorage();
                showNotification('All trades cleared', 'success');
            }
        });
    }

    // ==== MODAL HANDLERS ====
    const celebrationModal = document.getElementById('celebrationModal');
    const continueTradingBtn = document.getElementById('continueTradingBtn');
    const setNewGoalBtn = document.getElementById('setNewGoalBtn');

    if (continueTradingBtn) {
        continueTradingBtn.addEventListener('click', function() {
            celebrationModal.classList.add('hidden');
        });
    }

    if (setNewGoalBtn) {
        setNewGoalBtn.addEventListener('click', function() {
            celebrationModal.classList.add('hidden');
            document.getElementById('dailyGoal').focus();
        });
    }

    // Close modals when clicking outside
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('modal-overlay')) {
            e.target.parentElement.classList.add('hidden');
        }
    });

    // ==== CAPITAL MANAGEMENT BUTTONS ====
    const updateCapitalBtn = document.getElementById('updateCapitalFromProfits');
    const resetCapitalBtn = document.getElementById('resetToOriginal');

    if (updateCapitalBtn) {
        updateCapitalBtn.addEventListener('click', function() {
            const capitalInput = document.getElementById('capital');
            const currentCapital = parseFloat(capitalInput.value) || 0;
            const totalPnL = trades.reduce((sum, trade) => sum + trade.pnl, 0);
            const newCapital = currentCapital + totalPnL;
            
            if (confirm(`Update capital from $${currentCapital.toLocaleString()} to $${newCapital.toLocaleString()}?`)) {
                capitalInput.value = newCapital;
                showNotification('Capital updated successfully!', 'success');
                updateCapitalDisplay();
            }
        });
    }

    if (resetCapitalBtn) {
        resetCapitalBtn.addEventListener('click', function() {
            const originalCapital = parseFloat(document.getElementById('capital').value) || 0;
            if (confirm(`Reset capital to original amount of $${originalCapital.toLocaleString()}?`)) {
                updateCapitalDisplay();
                showNotification('Capital reset to original amount', 'success');
            }
        });
    }

    // ==== CLEAR FORM BUTTON ====
    const clearFormBtn = document.getElementById('clearEnhancedForm');
    if (clearFormBtn) {
        clearFormBtn.addEventListener('click', function() {
            enhancedTradeForm.reset();
            document.querySelectorAll('.calculated-pnl').forEach(el => {
                el.textContent = '$0.00';
                el.className = 'calculated-pnl';
            });
        });
    }

    // ==== DAILY GOAL PERSISTENCE ====
    const dailyGoalInput = document.getElementById('dailyGoal');
    if (dailyGoalInput) {
        const savedGoal = localStorage.getItem('dailyGoal');
        if (savedGoal) {
            dailyGoalInput.value = savedGoal;
        }
        
        dailyGoalInput.addEventListener('change', function() {
            localStorage.setItem('dailyGoal', this.value);
            updateDailyProgress();
        });
    }

    // Initial load
    setTimeout(() => {
        updateDailyProgress();
        renderLeaderboard();
    }, 100);
});